module.exports = __webpack_public_path__ + "static/paymentMethod-962de17f6e6053f013d0be876e248c90.png";